import { render } from "./BaseFilePreview.vue?vue&type=template&id=6bc72115"
import script from "./BaseFilePreview.vue?vue&type=script&lang=js"
export * from "./BaseFilePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__